const mutations = {
  SET_LOGIN_INFO (state, {userId = null, username = null, permission = null}) {
    state.userId = userId
    state.username = username
    state.permissions = permission
    state.expired = 'NO'
  },
  SET_EXPIRED_STATUS (state, {expireStatus = 'BYIDLE'}) {
    state.expired = expireStatus
  },
  DO_LOGOFF (state) {
    state.permissions = {}
    state.username = ''
    state.expired = 'PERMANENTLY'
    state.userId = null
  },
  SET_RELOGIN (state, {username = null, permission = null}) {
    state.username = username
    state.permissions = permission
    state.expired = 'NO'
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/view/login/state/mutations.js